// @ts-ignore
import * as React from "react";
import styled from "styled-components";
// import Text from "../Text/Text";

const FieldError = styled("span")`
  color: ${({ theme }) => theme.colors.error};
  font-size: ${({ theme }) => theme.fonts.sizes.h4};
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  width: 100%;
`;

export default FieldError;
